import React,{useState,useEffect,useRef} from "react";
import { Trans, useTranslation} from 'react-i18next'
import AvatarEditor from 'react-avatar-editor'
import Slider from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import errmsgicon from './../../../../../images/errormsgicon.png'
import profilepicempty from './../../../../../images/profilepicempty.png'
import Select from 'react-select'
import axios from "axios"; 
import CrossIcon from './../../../../../images/crossicon.png'
import Cookies from 'universal-cookie';
import ArtistNameSubmitted from './../../../../../images/artistnamesubmitted.png'
import Checkbox, { checkboxClasses } from '@mui/material/Checkbox';
import DisclaimerPopup from './../../../../../images/settingsdisclaimericon.png'
import ArrowDown from './../../../../../images/arrowdown.png'
import PeggyGouSpotify from './../../../../../images/peggygouspotify.png'
import DrakeSpotify from './../../../../../images/drakespotify.png'
import PeggyGouApple from './../../../../../images/peggygouapplemusic.png'
import { useNavigate} from "react-router-dom";
import { useJwt, decodeToken } from "react-jwt";

function ArtistName(){
    const {t, i18n } = useTranslation();
    const [artistnamepg,setArtistNamePg] = useState("artistname")
    const [artistName,setArtistName] = useState("")
    const [spotifyName,setSpotifyName] = useState("")
    const [spotifyLink,setSpotifyLink] = useState("")
    const [spotifyArr,setSpotifyArr] = useState([])
    const [isChecked1, setIsChecked1] = useState(false);
    const [isChecked2, setIsChecked2] = useState(false);    
    const [spotifyArrLoading,setSpotifyArrLoading] = useState(0)
    const [spotifyChecksArr,setSpotifyChecks] = useState([])
    const [spotifyArtSelected,setSpotifyArtSelected] = useState(false)
    const [existingartist,setExistingArtist] = useState()
    const [existingN3rveartist,setN3rveExistingArtist] = useState()
    const [appleArr,setAppleArr] = useState([])
    const [appleName,setAppleName] = useState("")
    const [appleLink,setAppleLink] = useState("")
    const cookies = new Cookies(null ,{ path: '/' });
    const [nextpage,setNextPage] = useState("artistname")
    const [previouspage,setPreviousPage] = useState("artistname") 
    const [disclaimer,setDisclaimer] = useState("")
    const navigate = useNavigate();

    const [dimensions, setDimensions] = useState({ 
        height: window.innerHeight,
        width: window.innerWidth
      })

    useEffect(()=>{
        console.log("Update")
        console.log(spotifyArr)
    },[spotifyArr])

    useEffect(()=>{
        console.log(spotifyArr)
      },[spotifyArrLoading])

      useEffect(()=>{
        if(artistName==="Drake"){
            setArtistNamePg("error")
        }
    },[artistName])

    useEffect(()=>{
        console.log("Output logged")
        console.log(artistnamepg)
    },[])

    const addArtistName = () =>{
        axios({
            method:'post',
            url:'https://n3rve.fly.dev/artists/name',
            headers:{
                Authorization: "Bearer ".concat(cookies.get("token"))
            },
            data:{
                artistName:artistName
            }
        }).then((res)=>{
           console.log("Artist name saved")
           console.log(res)
           cookies.set('token', res.data.token)

         })
         .catch((e)=>console.log(e))
    }


    const getSpotifyartists = (name,page) =>{
        console.log("Fired")
        axios({
            method:'get',
            url:'https://n3rve.fly.dev/artists/dsp?name='.concat(name).concat('&offset=0'),
            headers:{
                Authorization: "Bearer ".concat(cookies.get("token"))
            }
        }).then((res)=>{
            console.log(res)
          if(page==="artistname"){
                var error = false
                res.data.artists.items.map((item)=>{
                    if(name.toLowerCase()===item.name.toLowerCase() && item.followers.total>1000){
                        error= true
                        setExistingArtist(item)         
                    }
                })
               
                if(error){
                    setArtistNamePg("error")
                }else{
                    setArtistNamePg("spotifyname")
                }
          }

          if(page==="spotifyname"){
            var error = false
            console.log(name)

            res.data.artists.items.map((item)=>{
                if(name.toLowerCase()===item.name.toLowerCase() && item.followers.total>1000 && !error){
                    error= true
                    setExistingArtist(item)         
                }
            })
            
            if(error){
                setArtistNamePg("error")
            }else{
                var index=0
                const temp=[]
                const checks=[]
                res.data.artists.items.map((item)=>{
                    if(name.toLowerCase()===item.name.toLowerCase() && item.followers.total<1000){
                        // spotifyArr[index]=item 
                        // spotifyChecksArr[index]=false
                        temp.push(item)
                        checks.push(false)
                        // spotifyArr[index].set("Check",false)
                        index=index+1      
                    }
                })
                // setSpotifyArrLoading(Math.random())
                console.log(temp)
                setSpotifyArr(temp)
                setSpotifyChecks(checks)
                
            } 
          }
         })
         .catch((e)=>console.log(e))
    }

    const getNerveArtists = (name) =>{
        axios({
            method:'get',
            url:'https://n3rve.fly.dev/artists?name='.concat(name),
            headers:{
                Authorization: "Bearer ".concat(cookies.get("token"))
            }
        }).then((res)=>{
            var error = false
            res.data.artists.map((artist)=>{
                if(artist.name.toLowerCase()===name.toLowerCase()){
                    error=true
                    setN3rveExistingArtist(artist.name)
                }
            })
         })
         .catch((e)=>console.log(e))
    }

    const togglecheckbox = (no) =>{
        spotifyChecksArr.map((val,index)=>{
            if(no===index){
                spotifyChecksArr[index]=!val
            }else{
                spotifyChecksArr[index]=false
            }
        })
        setSpotifyArrLoading(Math.random())
        spotifySelected()
    }

    const spotifySelected = ()=>{
        setSpotifyArtSelected(false)

        spotifyChecksArr.map((val)=>{
            if(val){
                setSpotifyArtSelected(true)
            }
        })
    }

    useEffect(()=>{
            if(artistnamepg==="01" || artistnamepg==="success"){
                addArtistName()
            }
    },[artistnamepg])

 return (
     <div> 

         {/* {
                !viewSettings && artistnamepg==="-1" &&
                <div  style={{height:dimensions.height,width:'50%',display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginTop:'5em'}}>
                    <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',padding:'0.75em',marginLeft:'-3.5em',cursor:'pointer'}} onClick={()=>navigate("/Dashboard/settings")}/>
                    <div className="SetupArtistH1" >Let's set up Your Artist Name.</div>
                    <div className="SetupArtistH2" style={{marginTop:'1.42em'}}>Would you like to add your music to your current Spotify or Apple Music artist page?</div>
                    <div className="SetupArtistH4" style={{marginTop:'2.5em'}}>Have you released music before and want it to appear under your existing artist profile? Choose 'Yes' or 'No' to start a new one.</div>
                    <div style={{display:'flex',flexDirection:'row',marginTop:'2.5em'}}>
                        <div className="ArtistnameBtn" onClick={()=>setArtistNamePg("1")}>Yes, use existing page</div>
                        <div className="ArtistnameBtn" onClick={()=>setArtistNamePg("0")}>No, create now</div>
                    </div>
                </div>
            } */}


         {
                artistnamepg==="artistname" &&
                <div  style={{height:dimensions.height,width:'50%',display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginTop:'5em',position:'relative',marginLeft:'3em'}}>
                    <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',padding:'0.75em',cursor:'pointer',position:'absolute',top:'0em',right:'0em'}} onClick={()=>navigate("/Dashboard/settings")}/>
                    <div className="SetupArtistH3" style={{marginBottom:'2.22em'}}>Let's setup Your Artist Name</div>
                    <div className="SetupArtistH1" style={{marginBottom:'1em'}}>What artist name do you want to use for your music release?</div>
                    <div className="SetupArtistH4" style={{marginBottom:'2.5em'}}>Choose your very own artist name.<br/> Crafting your own artist name boosts your visibility among fans.</div>
                    
                    
                    <div className="ArtistNameInputHeader">
                        Artist Name
                    </div>

                    <input
                                        value={artistName}
                                        onChange={e => setArtistName(e.target.value)} 
                                        className="ArtistNameInput"
                                        type='text'
                                        placeholder="Enter artist name here..."
                                        // style={{marginLeft:'4.8em'}}
                                        />

                    
                    <div style={{display:'flex',flexDirection:'row'}}>
                    <div className="BackBtn2" style={{width:'11.25em',marginRight:'12.8em'}} onClick={()=>navigate("/Dashboard/settings")}>
                                {t('Back')} 
                                </div>

                        {
                            artistName.length===0 &&
                            <div className="NextBtn2" style={{width:'11.25em',backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}>
                            {t('Next')}  
                            </div>
                        }

                        {
                            artistName.length!==0 &&
                            <div className="NextBtn2" style={{width:'11.25em'}}  onClick={()=>{
                                                                                                getSpotifyartists(artistName,"artistname")
                                                                                                setPreviousPage("artistname");
                                                                                                setNextPage("spotifyname");
                                                                                                // setArtistNamePg("spotifyname"); 
                                                                                                cookies.set('artistname', artistName);
                                                                                                }}>
                            {t('Next')}  
                            </div>
                        }
                       
                    </div>

                </div>
            }

            {
                 artistnamepg==="01" &&
                <div  style={{height:dimensions.height,width:'50%',display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginTop:'5em'}}>
                    <img src={ArtistNameSubmitted} style={{height:'3em',width:'3em',marginBottom:'1em'}} />
                    <div className="SetupArtistH1" style={{marginBottom:'1em'}}>You’re Artist Name is Set!</div>
                    <span className="SetupArtistH3" style={{marginBottom:'2.5em'}}>Your tracks will be available under the name '<span style={{color:'#FF6694'}}>{cookies.get("artistname")}</span>' on Spotify, Apple<br/> Music, and over 00+  platforms.  Profile creation may take up to 3-5<br/> days.</span>
                    
                    <div className="Setupyourartistnamebtn" style={{marginTop:'1em',cursor:'pointer'}} onClick={()=>
                    {
                        if(cookies.get('token')!==undefined){

                            if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
                                navigate("/Dashboard/settings")
                             }
          
                            if(decodeToken(cookies.get('token')).info.role==="label"){
                                navigate("/dashboard/label/settings")
                            }
                
                        }}}>Done</div>

                </div>
            }

            {
                artistnamepg==="success" &&
                <div  style={{height:dimensions.height,width:'50%',display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginTop:'5em'}}>
                    <img src={ArtistNameSubmitted} style={{height:'3em',width:'3em',marginBottom:'1em'}} />
                    <div className="SetupArtistH1" style={{marginBottom:'1em'}}>You’re Artist Name is Set!</div>
                    <span className="SetupArtistH3" style={{marginBottom:'2.5em'}}>Your tracks will be available under the name '<span style={{color:'#FF6694'}}>{cookies.get("artistname")}</span>' on Spotify, Apple<br/> Music, and over 00+  platforms.</span>
                    
                    <div className="Setupyourartistnamebtn" style={{marginTop:'1em',cursor:'pointer'}} onClick={()=> {
                        if(cookies.get('token')!==undefined){

                            if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
                                navigate("/Dashboard/settings")
                             }
          
                            if(decodeToken(cookies.get('token')).info.role==="label"){
                                navigate("/dashboard/label/settings")
                            }
                
                        }}}>Done</div>

                </div>
            }

        {
                 artistnamepg==="spotifyname" &&
                <div  style={{height:dimensions.height,width:'50%',display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginTop:'5em',position:'relative',marginLeft:'3em'}}>
                    <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',padding:'0.75em',top:'0em',right:'0em',cursor:'pointer',position:'absolute'}} onClick={()=>navigate("/Dashboard/settings")}/>
                    <div className="SetupArtistH3" style={{marginBottom:'2.22em'}}>Let's setup Your Artist Name</div>

                    {
                        spotifyArr.length===0 &&
                        <div>
                            <div className="SetupArtistH1" style={{marginBottom:'1em'}}>What’s your Spotify artist name?</div>
                            <div className="SetupArtistH4" style={{marginBottom:'2.5em'}}>Enter your artist name exactly as it's listed.</div>
                            
                            <div className="ArtistNameInputHeader">
                                Artist Name
                            </div>

                            <input
                                                value={spotifyName}
                                                onChange={e => setSpotifyName(e.target.value)} 
                                                className="ArtistNameInput"
                                                type='text'
                                                placeholder="Enter artist name here..."
                                                // style={{marginLeft:'4.8em'}}
                                                />

                            <div className="Enterprofilelink" style={{marginTop:'-1.5em',marginLeft:'25em',marginBottom:'3em'}} onClick={()=>setArtistNamePg("spotifylink")}>
                                Enter profile link instead
                            </div>

                            <div style={{display:'flex',flexDirection:'row'}}>

                            <div className="BackBtn2" style={{width:'11.25em',marginRight:'12.8em'}} onClick={()=>setArtistNamePg(previouspage)}>
                                        {t('Back')} 
                            </div>

                                {
                                    spotifyName.length===0 &&
                                    <div className="NextBtn2" style={{width:'11.25em',backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}>
                                    {t('Next')}  
                                    </div>
                                }

                                {
                                    spotifyName.length!==0 &&
                                    <div className="NextBtn2" style={{width:'11.25em'}}  onClick={()=>{
                                                                    getSpotifyartists(spotifyName,"spotifyname")
                                                                    setPreviousPage("spotifyname");
                                                                    setNextPage("applename");
                                                                // if(artistName==="Drake")
                                                                // {
                                                                //     setArtistNamePg("error")
                                                                //     setNextPage("error")
                                                                //     setPreviousPage("spotifyname")
                                                                // }
                                                                // else
                                                                // {
                                                                //     setArtistNamePg("12")
                                                                // };
                                                                // cookies.set('artistname', artistName);
                                                                
                                                                }}>
                                    {t('Next')}  
                                    </div>
                                }
                            
                            </div>

                            <div className="SkipNotOnSpotify" onClick={()=>{setPreviousPage("spotifyname");setArtistNamePg("applename")}}>
                            Skip, I’m not on Spotify &#62;&#62;
                            </div>
                        </div>
                    }

                    {
                        spotifyArr.length!==0 &&
                        <div>
                             <span className="SetupArtistH1" style={{marginBottom:'2em'}}>Which ‘<span style={{color:'#7199FF'}}>{spotifyName}</span>’ are you on Spotify?</span>
                             <div style={{marginBottom:'2em'}}/>
                             {
                                spotifyArr.map((item,index)=>{
                                    return (
                                        <div>
                                        {
                                            !spotifyChecksArr[index] &&
                                            <div className="SpotifyProfileContainer">
                                            <div style={{marginRight:'1em'}}>
                                                {
                                                    item.images.length!==0 &&
                                                    <img src={item.images[0].url} style={{width:'4.25em',height:'4.25em',borderRadius:'99px',marginLeft:'1.5em'}}/>
                                                }
                                                 {
                                                    item.images.length===0 &&
                                                    <div  style={{width:'4.25em',height:'4.25em',borderRadius:'99px',marginLeft:'1.5em',backgroundColor:'#000000'}}/>
                                                }
                                                
                                            </div>
                                            <div style={{display:'flex',flexDirection:'column',width:'50%'}}>
                                                <div className="SpotifyArtistName">{item.name}</div>
                                                        {
                                                            item.genres.length!==0 && 
                                                            <span className="SpotifyArtistGenre">
                                                                {
                                                                    item.genres.map((genre,index)=>{
                                                                        if(index!== item.genres.length-1){
                                                                            return (
                                                                                <span>
                                                                            {genre}/&nbsp;
                                                                                </span>
                                                                            )
                                                                        }else{
                                                                            return (
                                                                                <span>
                                                                                &nbsp;{genre}
                                                                                </span>
                                                                            )
                                                                        }
                                                                    
                                                                    })
                                                                }
                                                            </span>
                                                        }
                                                {/* <div className="SpotifyArtistGenre">R&B / Soul</div> */}
                                            </div>
                    
                                            <div >
                                            <Checkbox checked={spotifyChecksArr[index]} onChange={()=>togglecheckbox(index)}  
                                                            iconStyle={{fill: '#FFFFFF'}}
                                                            sx={{
                                                                [`&, &.${checkboxClasses.checked}`]: {
                                                                    color: '#FFFFFF',
                                                                },
                                                                color: "#E91353",
                                                                '&.Mui-checked': {
                                                                color: "#E91353"
                                                                }
                                                            }}
                                                            />
                                            </div>
                                         </div>
                                        }
                    
                                        {
                                            spotifyChecksArr[index] &&
                                            <div className="SpotifyProfileContainer" style={{backgroundColor:'rgba(255,255,255,10%)'}}>
                                            <div style={{marginRight:'1em'}}>
                                                {
                                                    item.images.length!==0 &&
                                                    <img src={item.images[0].url} style={{width:'4.25em',height:'4.25em',borderRadius:'99px',marginLeft:'1.5em'}}/>
                                                }
                                                 {
                                                    item.images.length===0 &&
                                                    <div  style={{width:'4.25em',height:'4.25em',borderRadius:'99px',marginLeft:'1.5em',backgroundColor:'#000000'}}/>
                                                }
                                            </div>
                                            <div style={{display:'flex',flexDirection:'column',width:'50%'}}>
                                                <div className="SpotifyArtistName">{item.name}</div>
                                                {
                                                            item.genres.length!==0 && 
                                                            <span className="SpotifyArtistGenre">
                                                                {
                                                                    item.genres.map((genre,index)=>{
                                                                        if(index!== item.genres.length-1){
                                                                            return (
                                                                                <span>
                                                                            {genre}/&nbsp;
                                                                                </span>
                                                                            )
                                                                        }else{
                                                                            return (
                                                                                <span>
                                                                                &nbsp;{genre}
                                                                                </span>
                                                                            )
                                                                        }
                                                                    
                                                                    })
                                                                }
                                                            </span>
                                                        }
                                                {/* <div className="SpotifyArtistGenre">R&B / Soul</div> */}
                                            </div>
                    
                                            <div>
                                            <Checkbox checked={spotifyChecksArr[index]} onChange={()=>togglecheckbox(index)}  
                                                            iconStyle={{fill: '#FFFFFF'}}
                                                            sx={{
                                                                [`&, &.${checkboxClasses.checked}`]: {
                                                                    color: '#FFFFFF',
                                                                },
                                                                color: "#E91353",
                                                                '&.Mui-checked': {
                                                                color: "#E91353"
                                                                }
                                                            }}
                                                            />
                                            </div>
                                         </div>
                                        }
                                        </div>
                                    )
                                })
                             }
                            <div style={{display:'flex',flexDirection:'row',marginTop:'2em'}}>

                            <div className="BackBtn2" style={{width:'11.25em',marginRight:'12.8em'}} onClick={()=>setSpotifyArr([])}>
                                        {t('Back')} 
                            </div>

                            {
                                        !spotifyArtSelected &&
                                        <div className="NextBtn2" style={{width:'11.25em',backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}>
                                        {t('Next')}  
                                        </div>
                            }

                            {
                                        spotifyArtSelected &&
                                        <div className="NextBtn2" style={{width:'11.25em'}}  onClick={()=>{
                                                                        setPreviousPage("spotifyname");
                                                                        setNextPage("applename");
                                                                        setArtistNamePg("applename")
                                                                    // if(artistName==="Drake")
                                                                    // {
                                                                    //     setArtistNamePg("error")
                                                                    //     setNextPage("error")
                                                                    //     setPreviousPage("spotifyname")
                                                                    // }
                                                                    // else
                                                                    // {
                                                                    //     setArtistNamePg("12")
                                                                    // };
                                                                    // cookies.set('artistname', artistName);
                                                                    
                                                                    }}>
                                        {t('Next')}  
                                        </div>
                            }

                            </div>

                        </div>
                    }


                </div>
            }

            
        {
                 artistnamepg==="applename" &&
                <div  style={{height:dimensions.height,width:'50%',display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginTop:'5em',marginLeft:'3em',position:'relative'}}>
                    <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',padding:'0.75em',marginLeft:'-3.5em',cursor:'pointer',position:'absolute',top:'0em',right:'0em'}} onClick={()=>navigate("/Dashboard/settings")}/>
                    <div className="SetupArtistH3" style={{marginBottom:'2.22em'}}>Let's setup Your Artist Name</div>
                    <div className="SetupArtistH1" style={{marginBottom:'1em'}}>What’s your Apple Music Artist name?</div>
                    <div className="SetupArtistH4" style={{marginBottom:'2.5em'}}>Enter your artist name exactly as it's listed.</div>
                    
                    <div className="ArtistNameInputHeader">
                        Artist Name
                    </div>

                    <input
                                        value={appleName}
                                        onChange={e => setAppleName(e.target.value)} 
                                        className="ArtistNameInput"
                                        type='text'
                                        placeholder="Enter artist name here..."
                                        // style={{marginLeft:'4.8em'}}
                                        />

                    <div className="Enterprofilelink" style={{marginTop:'-1.5em',marginLeft:'25em',marginBottom:'3em'}} onClick={()=>setArtistNamePg("spotifylink")}>
                        Enter profile link instead
                    </div>

                    <div style={{display:'flex',flexDirection:'row'}}>

                    <div className="BackBtn2" style={{width:'11.25em',marginRight:'12.8em'}} onClick={()=>setArtistNamePg(previouspage)}>
                                {t('Back')} 
                    </div>

                        {
                            appleName.length===0 &&
                            <div className="NextBtn2" style={{width:'11.25em',backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}>
                            {t('Next')}  
                            </div>
                        }

                        {
                            appleName.length!==0 &&
                            <div className="NextBtn2" style={{width:'11.25em'}}  onClick={()=>{
                                                        setArtistNamePg("121")
                                                        // if(artistName==="Drake")
                                                        // {
                                                        //     setArtistNamePg("error")
                                                        //     setNextPage("error")
                                                        //     setPreviousPage("spotifyname")
                                                        // }
                                                        // else
                                                        // {
                                                        //     setArtistNamePg("12")
                                                        // };
                                                        // cookies.set('artistname', artistName);
                                                        
                                                        }}>
                            {t('Next')}  
                            </div>
                        }
                       
                    </div>

                    <div className="SkipNotOnSpotify" onClick={()=>setArtistNamePg("success")}>
                     Skip, I’m not on Apple Music &#62;&#62;
                    </div>


                </div>
            }

        {
                 artistnamepg==="error" &&
                <div  style={{height:dimensions.height,width:'50%',display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginTop:'5em',position:'relative',marginLeft:'3em'}}>
                    <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',padding:'0.75em',cursor:'pointer',position:'absolute',top:'0em',right:'0em'}} onClick={()=>navigate("/Dashboard/settings")}/>
                    <div className="SetupArtistH3" style={{marginBottom:'2.22em'}}>Let's setup Your Artist Name</div>
                    <span className="SetupArtistH1" style={{marginBottom:'1em'}}>Sorry, the distribution of music under the name '<span style={{color:'#FFA471'}}>{existingartist.name}</span>' on Spotify or Apple Music is not permitted.</span>
                    
                    <div className="SpotifyProfileContainer" style={{marginBottom:'0em'}}>
                        <div style={{marginRight:'1em'}}>
                            <img src={existingartist.images[0].url} style={{width:'4.25em',height:'4.25em',borderRadius:'99px',marginLeft:'1.5em'}}/>
                        </div>
                        <div style={{display:'flex',flexDirection:'column',width:'50%'}}>
                            <div className="SpotifyArtistName">{existingartist.name}</div>
                            {
                                existingartist.genres.length!==0 && 
                                <span className="SpotifyArtistGenre">
                                    {
                                        existingartist.genres.map((genre,index)=>{
                                            if(index!== existingartist.genres.length-1){
                                                return (
                                                    <span>
                                                   {genre},&nbsp;
                                                    </span>
                                                )
                                            }else{
                                                return (
                                                    <span>
                                                    &nbsp;{genre}
                                                    </span>
                                                )
                                            }
                                          
                                        })
                                    }
                                </span>
                            }
                            {/* <div className="SpotifyArtistGenre">Canadian Hip Hop, Canadian Pop, Hip Hop, Pop Rap, Rap</div> */}
                            <div className="SpotifyArtistGenre">{existingartist.followers.total.toLocaleString('en', {useGrouping:true})} followers</div>
                        </div>

                        <div>
                        </div>
                     </div>
                   

                    <div style={{display:'flex',flexDirection:'row',marginTop:'2.5em'}}>
                    <div className="BackBtn2" style={{width:'11.25em',marginRight:'12.8em'}} onClick={()=>setArtistNamePg(previouspage)}>
                                {t('Back')} 
                                </div>

                       
                    </div>

                </div>
            }

    {       
                 artistnamepg==="12" &&
                <div  style={{height:dimensions.height,width:'50%',display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginTop:'5em',marginLeft:'3em'}}>
                    <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',padding:'0.75em',marginLeft:'-3.5em',cursor:'pointer',position:'absolute',top:'0em',right:'0em'}} onClick={()=>navigate("/Dashboard/settings")}/>
                    <div className="SetupArtistH3" style={{marginBottom:'2.22em'}}>Let's setup Your Artist Name</div>
                    <span className="SetupArtistH1" style={{marginBottom:'1em'}}>Which ‘<span style={{color:'#7199FF'}}>{artistName}</span>’ are you on Spotify?</span>
            
                    
                    {
                        !isChecked1 &&
                        <div className="SpotifyProfileContainer" style={{marginBottom:'0em'}}>
                        <div style={{marginRight:'1em'}}>
                            <img src={PeggyGouSpotify} style={{width:'4.25em',height:'4.25em',borderRadius:'99px',marginLeft:'1.5em'}}/>
                        </div>
                        <div style={{display:'flex',flexDirection:'column',width:'50%'}}>
                            <div className="SpotifyArtistName">Peggy Gou</div>
                            <div className="SpotifyArtistGenre">R&B / Soul</div>
                        </div>

                        <div >
                        <Checkbox checked={isChecked1} onChange={()=>setIsChecked1(!isChecked1)}  
                                        iconStyle={{fill: '#FFFFFF'}}
                                        sx={{
                                            [`&, &.${checkboxClasses.checked}`]: {
                                                color: '#FFFFFF',
                                            },
                                            color: "#E91353",
                                            '&.Mui-checked': {
                                            color: "#E91353"
                                            }
                                        }}
                                        />
                        </div>
                     </div>
                    }

                    {
                        isChecked1 &&
                        <div className="SpotifyProfileContainer" style={{backgroundColor:'rgba(255,255,255,10%)',marginBottom:'0em'}}>
                        <div style={{marginRight:'1em'}}>
                            <img src={PeggyGouSpotify} style={{width:'4.25em',height:'4.25em',borderRadius:'99px',marginLeft:'1.5em'}}/>
                        </div>
                        <div style={{display:'flex',flexDirection:'column',width:'50%'}}>
                            <div className="SpotifyArtistName">Peggy Gou</div>
                            <div className="SpotifyArtistGenre">R&B / Soul</div>
                        </div>

                        <div >
                        <Checkbox checked={isChecked1} onChange={()=>setIsChecked1(!isChecked1)}  
                                        iconStyle={{fill: '#FFFFFF'}}
                                        sx={{
                                            [`&, &.${checkboxClasses.checked}`]: {
                                                color: '#FFFFFF',
                                            },
                                            color: "#E91353",
                                            '&.Mui-checked': {
                                            color: "#E91353"
                                            }
                                        }}
                                        />
                        </div>
                     </div>
                    }

                    <div style={{display:'flex',flexDirection:'row',marginTop:'2.5em'}}>
                    <div className="BackBtn2" style={{width:'11.25em',marginRight:'12.8em'}} onClick={()=>setArtistNamePg("spotifylink")}>
                                {t('Back')} 
                                </div>

                        {
                            !isChecked1 &&
                            <div className="NextBtn2" style={{width:'11.25em',backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}>
                            {t('Next')}  
                            </div>
                        }

                        {
                            isChecked1 &&
                            <div className="NextBtn2" style={{width:'11.25em'}}  onClick={()=>{setArtistNamePg("121"); cookies.set('artistname', artistName);}}>
                            {t('Next')}  
                            </div>
                        }
                       
                    </div>



                </div>
            }  

             {       
                 artistnamepg==="121" &&
                <div  style={{height:dimensions.height,width:'50%',display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginTop:'5em',marginLeft:'3em',position:'relative'}}>
                    <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',padding:'0.75em',marginLeft:'-3.5em',cursor:'pointer',position:'absolute',top:'0em',right:'0em'}} onClick={()=>navigate("/Dashboard/settings")}/>
                    <div className="SetupArtistH3" style={{marginBottom:'2.22em'}}>Let's setup Your Artist Name</div>
                    <span className="SetupArtistH1" style={{marginBottom:'1em'}}>Which ‘<span style={{color:'#7199FF'}}>{artistName}</span>’ are you on Apple Music?</span>
            
                    
                    {
                        !isChecked1 &&
                        <div className="SpotifyProfileContainer">
                        <div style={{marginRight:'1em'}}>
                            <img src={PeggyGouApple} style={{width:'4.25em',height:'4.25em',borderRadius:'99px',marginLeft:'1.5em'}}/>
                        </div>
                        <div style={{display:'flex',flexDirection:'column',width:'50%'}}>
                            <div className="SpotifyArtistName">Peggy Gou</div>
                            <div className="SpotifyArtistGenre">R&B / Soul</div>
                        </div>

                        <div >
                        <Checkbox checked={isChecked1} onChange={()=>setIsChecked1(!isChecked1)}  
                                        iconStyle={{fill: '#FFFFFF'}}
                                        sx={{
                                            [`&, &.${checkboxClasses.checked}`]: {
                                                color: '#FFFFFF',
                                            },
                                            color: "#E91353",
                                            '&.Mui-checked': {
                                            color: "#E91353"
                                            }
                                        }}
                                        />
                        </div>
                     </div>
                    }

                    {
                        isChecked1 &&
                        <div className="SpotifyProfileContainer" style={{backgroundColor:'rgba(255,255,255,10%)'}}>
                        <div style={{marginRight:'1em'}}>
                            <img src={PeggyGouApple} style={{width:'4.25em',height:'4.25em',borderRadius:'99px',marginLeft:'1.5em'}}/>
                        </div>
                        <div style={{display:'flex',flexDirection:'column',width:'50%'}}>
                            <div className="SpotifyArtistName">Peggy Gou</div>
                            <div className="SpotifyArtistGenre">R&B / Soul</div>
                        </div>

                        <div >
                        <Checkbox checked={isChecked1} onChange={()=>setIsChecked1(!isChecked1)}  
                                        iconStyle={{fill: '#FFFFFF'}}
                                        sx={{
                                            [`&, &.${checkboxClasses.checked}`]: {
                                                color: '#FFFFFF',
                                            },
                                            color: "#E91353",
                                            '&.Mui-checked': {
                                            color: "#E91353"
                                            }
                                        }}
                                        />
                        </div>
                     </div>
                    }
                    {
                        !isChecked2 &&
                        <div className="SpotifyProfileContainer">
                        <div style={{marginRight:'1em'}}>
                            <img src={PeggyGouApple} style={{width:'4.25em',height:'4.25em',borderRadius:'99px',marginLeft:'1.5em'}}/>
                        </div>
                        <div style={{display:'flex',flexDirection:'column',width:'50%'}}>
                            <div className="SpotifyArtistName">Peggy Gou</div>
                            <div className="SpotifyArtistGenre">R&B / Soul</div>
                        </div>

                        <div >
                        <Checkbox checked={isChecked2} onChange={()=>setIsChecked2(!isChecked2)}  
                                        iconStyle={{fill: '#FFFFFF'}}
                                        sx={{
                                            [`&, &.${checkboxClasses.checked}`]: {
                                                color: '#FFFFFF',
                                            },
                                            color: "#E91353",
                                            '&.Mui-checked': {
                                            color: "#E91353"
                                            }
                                        }}
                                        />
                        </div>
                     </div>
                    }

                    {
                        isChecked2 &&
                        <div className="SpotifyProfileContainer" style={{backgroundColor:'rgba(255,255,255,10%)'}}>
                        <div style={{marginRight:'1em'}}>
                            <img src={PeggyGouApple} style={{width:'4.25em',height:'4.25em',borderRadius:'99px',marginLeft:'1.5em'}}/>
                        </div>
                        <div style={{display:'flex',flexDirection:'column',width:'50%'}}>
                            <div className="SpotifyArtistName">Peggy Gou</div>
                            <div className="SpotifyArtistGenre">Electronic/ House</div>
                        </div>

                        <div >
                        <Checkbox checked={isChecked2} onChange={()=>setIsChecked2(!isChecked2)}  
                                        iconStyle={{fill: '#FFFFFF'}}
                                        sx={{
                                            [`&, &.${checkboxClasses.checked}`]: {
                                                color: '#FFFFFF',
                                            },
                                            color: "#E91353",
                                            '&.Mui-checked': {
                                            color: "#E91353"
                                            }
                                        }}
                                        />
                        </div>
                     </div>
                    }

                    <div style={{display:'flex',flexDirection:'row',marginTop:'2.5em'}}>
                    <div className="BackBtn2" style={{width:'11.25em',marginRight:'12.8em'}} onClick={()=>setArtistNamePg("131")}>
                                {t('Back')} 
                                </div>

                        {
                            !isChecked1 && !isChecked2 &&
                            <div className="NextBtn2" style={{width:'11.25em',backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}>
                            {t('Next')}  
                            </div>
                        }

                        {
                            (isChecked1 || isChecked2) &&
                            <div className="NextBtn2" style={{width:'11.25em'}}  onClick={()=>{setArtistNamePg("success"); cookies.set('artistname', artistName);}}>
                            {t('Next')}  
                            </div>
                        }
                       
                    </div>



                </div>
            }      

            {
                 artistnamepg==="spotifylink" &&
                <div  style={{height:dimensions.height,width:'50%',display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginTop:'5em',marginLeft:'3em',position:'relative'}}>
                    <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',padding:'0.75em',marginLeft:'-3.5em',cursor:'pointer',position:'absolute',top:'0em',right:'0em'}} onClick={()=>navigate("/Dashboard/settings")}/>
                    <div className="SetupArtistH3" style={{marginBottom:'2.22em'}}>Let's setup Your Artist Name</div>
                    <div className="SetupArtistH1" style={{marginBottom:'1em'}}>What’s your Spotify artist profile link?</div>
                    <div className="SetupArtistH4" style={{marginBottom:'2.5em'}}>Enter url link of your artist profile on Spotify.</div>
                    
                    <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',justifyContent:'flex-start',position:'relative'}}>
                    <div className="ArtistNameInputHeader" >
                        Profile Link
                    </div>
                    <img src={DisclaimerPopup} style={{width:'1em',height:'1em',marginTop:'-0.1em',marginLeft:'1em',padding:'0.4em'}} className="DisclaimerHover" onMouseOver={()=>setDisclaimer("spotifylink")} onMouseLeave={()=>setDisclaimer("")}/>
                    {  
                                    disclaimer==="spotifylink" &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-10.1em',marginLeft:'0em'}} onMouseOver={()=>setDisclaimer("spotifylink")} onMouseLeave={()=>setDisclaimer("")}>
                                        <div className='DisclaimerContainer' style={{width:'15.43em'}}>
                                        A profile link is a URL that leads directly to your Spotify profile, allowing others to view and follow your playlists and favorite tracks.
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'5.8em',top:'9.2em'}}/>
                                      </div>
                                    }
                    </div>

                    <input
                                        value={spotifyLink}
                                        onChange={e => setSpotifyLink(e.target.value)} 
                                        className="ArtistNameInput"
                                        type='text'
                                        placeholder="https:// ..."
                                        // style={{marginLeft:'4.8em'}}
                                        />

                    <div className="Enterprofilelink" style={{marginTop:'-1.5em',marginLeft:'25em',marginBottom:'3em'}} onClick={()=>setArtistNamePg("spotifyname")}>
                        Enter artist name instead
                    </div>

                    <div style={{display:'flex',flexDirection:'row',marginTop:'2.5em'}}>
                    <div className="BackBtn2" style={{width:'11.25em',marginRight:'12.8em'}} onClick={()=>setArtistNamePg("spotifyname")}>
                                {t('Back')} 
                                </div>

                        {
                            spotifyLink.length===0 &&
                            <div className="NextBtn2" style={{width:'11.25em',backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}>
                            {t('Next')}  
                            </div>
                        }

                        {
                            spotifyLink.length!==0 &&
                            <div className="NextBtn2" style={{width:'11.25em'}}  onClick={()=>{setArtistNamePg("1311"); cookies.set('artistname', artistName);}}>
                            {t('Next')}  
                            </div>
                        }
                       
                    </div>

                    <div className="SkipNotOnSpotify" onClick={()=>setArtistNamePg("132")}>
                     Skip, I’m not on Spotify &#62;&#62;
                    </div>


                </div>
            }

        {
                 artistnamepg==="1311" &&
                <div  style={{height:dimensions.height,width:'50%',display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginTop:'5em',marginLeft:'3em',position:'relative'}}>
                    <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',padding:'0.75em',marginLeft:'-3.5em',cursor:'pointer',position:'absolute',top:'0em',right:'0em'}} onClick={()=>navigate("/Dashboard/settings")}/>
                    <div className="SetupArtistH3" style={{marginBottom:'2.22em'}}>Let's setup Your Artist Name</div>
                    <div className="SetupArtistH1" style={{marginBottom:'1em'}}>Confirm this is your Spotify Profile</div>
            
                    
                    {
                        !isChecked1 &&
                        <div className="SpotifyProfileContainer">
                        <div style={{marginRight:'1em'}}>
                            <img src={PeggyGouSpotify} style={{width:'4.25em',height:'4.25em',borderRadius:'99px',marginLeft:'1.5em'}}/>
                        </div>
                        <div style={{display:'flex',flexDirection:'column',width:'50%'}}>
                            <div className="SpotifyArtistName">Peggy Gou</div>
                            <div className="SpotifyArtistGenre">R&B / Soul</div>
                        </div>

                        <div >
                        <Checkbox checked={isChecked1} onChange={()=>setIsChecked1(!isChecked1)}  
                                        iconStyle={{fill: '#FFFFFF'}}
                                        sx={{
                                            [`&, &.${checkboxClasses.checked}`]: {
                                                color: '#FFFFFF',
                                            },
                                            color: "#E91353",
                                            '&.Mui-checked': {
                                            color: "#E91353"
                                            }
                                        }}
                                        />
                        </div>
                     </div>
                    }

                    {
                        isChecked1 &&
                        <div className="SpotifyProfileContainer" style={{backgroundColor:'rgba(255,255,255,10%)'}}>
                        <div style={{marginRight:'1em'}}>
                            <img src={PeggyGouSpotify} style={{width:'4.25em',height:'4.25em',borderRadius:'99px',marginLeft:'1.5em'}}/>
                        </div>
                        <div style={{display:'flex',flexDirection:'column',width:'50%'}}>
                            <div className="SpotifyArtistName">Peggy Gou</div>
                            <div className="SpotifyArtistGenre">R&B / Soul</div>
                        </div>

                        <div >
                        <Checkbox checked={isChecked1} onChange={()=>setIsChecked1(!isChecked1)}  
                                        iconStyle={{fill: '#FFFFFF'}}
                                        sx={{
                                            [`&, &.${checkboxClasses.checked}`]: {
                                                color: '#FFFFFF',
                                            },
                                            color: "#E91353",
                                            '&.Mui-checked': {
                                            color: "#E91353"
                                            }
                                        }}
                                        />
                        </div>
                     </div>
                    }

                    <div style={{display:'flex',flexDirection:'row',marginTop:'2.5em'}}>
                    <div className="BackBtn2" style={{width:'11.25em',marginRight:'12.8em'}} onClick={()=>setArtistNamePg("131")}>
                                {t('Back')} 
                                </div>

                        {
                            !isChecked1 &&
                            <div className="NextBtn2" style={{width:'11.25em',backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}>
                            {t('Next')}  
                            </div>
                        }

                        {
                            isChecked1 &&
                            <div className="NextBtn2" style={{width:'11.25em'}}  onClick={()=>{setArtistNamePg("success"); cookies.set('artistname', artistName);}}>
                            {t('Next')}  
                            </div>
                        }
                       
                    </div>



                </div>
            }

            {
                artistnamepg==="132" &&
                <div  style={{height:dimensions.height,width:'50%',display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginTop:'5em',marginLeft:'3em',position:'relative'}}>
                    <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',padding:'0.75em',marginLeft:'-3.5em',cursor:'pointer',position:'absolute',top:'0em',right:'0em'}} onClick={()=>navigate("/Dashboard/settings")}/>
                    <div className="SetupArtistH3" style={{marginBottom:'2.22em'}}>Let's setup Your Artist Name</div>
                    <div className="SetupArtistH1" style={{marginBottom:'1em'}}>Enter your Apple Music profile link.</div>
                    
                    <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',justifyContent:'flex-start',position:'relative'}}>
                    <div className="ArtistNameInputHeader">
                        Profile Link
                    </div>
                    <img src={DisclaimerPopup} style={{width:'1em',height:'1em',marginTop:'-0.1em',marginLeft:'1em',padding:'0.4em'}} className="DisclaimerHover" onMouseOver={()=>setDisclaimer("applelink")} onMouseLeave={()=>setDisclaimer("")} />
                    {  
                                    disclaimer==="applelink" &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-8.1em',marginLeft:'0em'}} onMouseOver={()=>setDisclaimer("applelink")} onMouseLeave={()=>setDisclaimer("")}>
                                        <div className='DisclaimerContainer' style={{width:'15.43em'}}>
                                        A profile link is your artist page URL for music streaming platforms like Spotify, Apple Music.
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'5.8em',top:'7.3em'}}/>
                                      </div>
                                    }
                    </div>

                    <input
                                        value={appleLink}
                                        onChange={e => setAppleLink(e.target.value)} 
                                        className="ArtistNameInput"
                                        type='text'
                                        placeholder="https:// ..."
                                        // style={{marginLeft:'4.8em'}}
                                        />

                    <div className="Enterprofilelink" style={{marginTop:'-1.5em',marginLeft:'25em',marginBottom:'3em'}} onClick={()=>setArtistNamePg("applename")}>
                        Enter Apple Music name instead
                    </div>

                    <div style={{display:'flex',flexDirection:'row',marginTop:'2.5em'}}>
                    <div className="BackBtn2" style={{width:'11.25em',marginRight:'12.8em'}} onClick={()=>setArtistNamePg("spotifylink")}>
                                {t('Back')} 
                                </div>

                        {
                            appleLink.length===0 &&
                            <div className="NextBtn2" style={{width:'11.25em',backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}>
                            {t('Next')}  
                            </div>
                        }

                        {
                            appleLink.length!==0 &&
                            <div className="NextBtn2" style={{width:'11.25em'}}  onClick={()=>{setArtistNamePg("1321"); cookies.set('artistname', artistName);}}>
                            {t('Next')}  
                            </div>
                        }
                       
                    </div>

                    <div className="SkipNotOnSpotify" style={{marginLeft:"18.7em"}}  onClick={()=>setArtistNamePg("success")}>
                     Skip, I’m not on Apple Music &#62;&#62;
                    </div>


                </div>
            }

            {
                 artistnamepg==="1321" &&
                <div  style={{height:dimensions.height,width:'50%',display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginTop:'5em',marginLeft:'3em',position:'relative'}}>
                    <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',padding:'0.75em',marginLeft:'-3.5em',cursor:'pointer',position:'absolute',top:'0em',right:'0em'}} onClick={()=>navigate("/Dashboard/settings")}/>
                    <div className="SetupArtistH3" style={{marginBottom:'2.22em'}}>Let's setup Your Artist Name</div>
                    <div className="SetupArtistH1" style={{marginBottom:'1em'}}>Confirm this is your Apple Music Profile</div>
            
                    
                    {
                        !isChecked1 &&
                        <div className="SpotifyProfileContainer">
                        <div style={{marginRight:'1em'}}>
                            <img src={PeggyGouApple} style={{width:'4.25em',height:'4.25em',borderRadius:'99px',marginLeft:'1.5em'}}/>
                        </div>
                        <div style={{display:'flex',flexDirection:'column',width:'50%'}}>
                            <div className="SpotifyArtistName">Peggy Gou</div>
                            <div className="SpotifyArtistGenre">R&B / Soul</div>
                        </div>

                        <div >
                        <Checkbox checked={isChecked1} onChange={()=>setIsChecked1(!isChecked1)}  
                                        iconStyle={{fill: '#FFFFFF'}}
                                        sx={{
                                            [`&, &.${checkboxClasses.checked}`]: {
                                                color: '#FFFFFF',
                                            },
                                            color: "#E91353",
                                            '&.Mui-checked': {
                                            color: "#E91353"
                                            }
                                        }}
                                        />
                        </div>
                     </div>
                    }

                    {
                        isChecked1 &&
                        <div className="SpotifyProfileContainer" style={{backgroundColor:'rgba(255,255,255,10%)'}}>
                        <div style={{marginRight:'1em'}}>
                            <img src={PeggyGouSpotify} style={{width:'4.25em',height:'4.25em',borderRadius:'99px',marginLeft:'1.5em'}}/>
                        </div>
                        <div style={{display:'flex',flexDirection:'column',width:'50%'}}>
                            <div className="SpotifyArtistName">Peggy Gou</div>
                            <div className="SpotifyArtistGenre">R&B / Soul</div>
                        </div>

                        <div >
                        <Checkbox checked={isChecked1} onChange={()=>setIsChecked1(!isChecked1)}  
                                        iconStyle={{fill: '#FFFFFF'}}
                                        sx={{
                                            [`&, &.${checkboxClasses.checked}`]: {
                                                color: '#FFFFFF',
                                            },
                                            color: "#E91353",
                                            '&.Mui-checked': {
                                            color: "#E91353"
                                            }
                                        }}
                                        />
                        </div>
                     </div>
                    }

                    <div style={{display:'flex',flexDirection:'row',marginTop:'2.5em'}}>
                    <div className="BackBtn2" style={{width:'11.25em',marginRight:'12.8em'}} onClick={()=>setArtistNamePg("131")}>
                                {t('Back')} 
                                </div>

                        {
                            !isChecked1 &&
                            <div className="NextBtn2" style={{width:'11.25em',backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}>
                            {t('Next')}  
                            </div>
                        }

                        {
                            isChecked1 &&
                            <div className="NextBtn2" style={{width:'11.25em'}}  onClick={()=>{setArtistNamePg("success"); cookies.set('artistname', artistName);}}>
                            {t('Next')}  
                            </div>
                        }
                       
                    </div>



                </div>
            }

                  
      </div>
 )
}

export default ArtistName;